import React from 'react'

import Typography from '@mui/material/Typography'

interface ResponsiveTableHeaderProps {
  header: string
}

const ResponsiveTableHeader = (props: ResponsiveTableHeaderProps): JSX.Element => {
  return (
    <Typography sx={{ fontWeight: 'bold' }} variant="body2" className="responsive-table-header">
      {`${props.header}:`}
    </Typography>
  )
}

export default ResponsiveTableHeader
